import { useCallback, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
// import { useSelector } from "react-redux";
// import { appState } from "$reducers";
// import useAuth from "$hooks/useAuth";
// import { queryClient } from "$utils/queryClient";
import useDockyardForm from "$hooks/useDockyardForm";
import useProjectForm from "$hooks/useProjectForm";
// import { DockyardServices } from "$services";
import { useEDBFormContext } from "../context/EDBFormContext";

export default function useProjectDockPicker() {
  // Import form and popin utilities
  const {
    classes: dockClass,
    togglePopin: toggleDockPopin,
    handleSubmit: onSubmitDockyard,
    isOpened: isDockyardPopinOpened,
    error: errorDockyard,
    openPopin: openDockyardPopin,
    submitting: submittingDockyard,
  } = useDockyardForm();

  const {
    togglePopin: togglePopinProject,
    error: errorProject,
    isOpened: isOpenedProject,
    handleSubmit: onSubmitProject,
    submitting: submittingProject,
    openPopin: openProjectPopin,
  } = useProjectForm();

  // State for dockyard form defaults
  const [defaultValuesDockyardForm, setDefaultValuesDockyardForm] = useState(
    {}
  );
  // const [dockyardFilter, setDockyardFilter] = useState(null);

  // const { filter: companySidebarFilter } = useSelector(appState);

  // check if i can use this instead of getting it from the context
  //   const { filter: sidebarCompanyFilter } = useSelector(appState);
  const {
    currentProject,
    projectOptions: projectFilter,
    dockyardOptions: dockyardFilter,
  } = useEDBFormContext();

  const { setValue, getValues } = useFormContext();

  // Refs to prevent circular updates
  const updatingProjectRef = useRef(false);
  const updatingDockyardRef = useRef(false);

  // const { isContributor } = useAuth();

  // // Query Projects
  // const queryKeyProject = useMemo(
  //   () => ({
  //     rowsPerPage: 10000,
  //     isActive: true,
  //     companyDisable: false,
  //     ...(companySidebarFilter &&
  //       !isContributor() && {
  //         companyName: companySidebarFilter.name,
  //       }),
  //   }),
  //   [companySidebarFilter, isContributor]
  // );

  // const { data: projectFilter } = useQuery(
  //   ["getProjects", queryKeyProject],
  //   () => ProjectServices.getProjects(queryKeyProject),
  //   { gcTime: 5 * 60 * 1000 }
  // );

  // Query Dockyards

  // const fetchDockyards = useCallback(async () => {
  //   const filters = {
  //     ...{ isActive: true },
  //     ...{ companyDisable: false },
  //     ...(companySidebarFilter &&
  //       !isContributor() && {
  //         company: companySidebarFilter._id,
  //       }),
  //   };
  //   let getDockyard = await queryClient.getQueryData(["getDockyards", filters]);
  //   if (!getDockyard) {
  //     getDockyard = await queryClient.fetchQuery(
  //       ["getDockyards", filters],
  //       () => DockyardServices.getDockyards(filters),
  //       {
  //         staleTime: 1000 * 60,
  //       }
  //     );
  //   }
  //   setDockyardFilter(getDockyard);
  // }, [setDockyardFilter, companySidebarFilter, isContributor]);

  // useEffect(() => {
  //   fetchDockyards();
  // }, [fetchDockyards]);

  /**
   * Creates a new project and sets form values
   */
  const handleCreateProject = useCallback(
    async (data) => {
      if (data) {
        const project = await onSubmitProject(data);
        if (!project?.error) {
          // Backend may return Prisma field name (companyId) instead of (company)
          const projectCompanyId = project.companyId || project.company;

          // Set dockyard form defaults
          setDefaultValuesDockyardForm({
            company: projectCompanyId,
            project: project._id,
          });

          // Update form values
          setValue("company", projectCompanyId);
          setValue("dockyard", null);
          setValue("project", project._id);
        }
      }
    },
    [onSubmitProject, setDefaultValuesDockyardForm, setValue]
  );

  /**
   * Creates a new dockyard and sets form values
   */
  const handleCreateDockyard = useCallback(
    async (data) => {
      if (data) {
        const yard = await onSubmitDockyard(data);

        if (!yard?.error) {
          // Set form values
          // Note: Backend returns Prisma field names (companyId, projectId)
          // not the legacy Mongoose names (company, project)
          const yardCompanyId = yard.companyId || yard.company;
          const yardProjectId = yard.projectId || yard.project;

          updatingDockyardRef.current = true;
          try {
            setValue("company", yardCompanyId);
            setValue("project", yardProjectId);
            setValue("dockyard", yard._id);
            setValue("dispositionAdress", yard.address);
            setValue("dispositionAdress2", yard.address2);
            setValue("dispositionPostalCode", yard.postalCode);
            setValue("dispositionCity", yard.city);
            setValue("dispositionCountry", yard.country);
            setValue("intervenantCompany", yard.interveningCompany?.[0]?._id);
            setValue("intervenantContact", null);
          } finally {
            setTimeout(() => {
              updatingDockyardRef.current = false;
            }, 0);
          }
        }
      }
    },
    [onSubmitDockyard, setValue]
  );

  /**
   * Handles project selection change
   * Sets company and clears dockyard when project changes
   */
  const handleProjectChange = useCallback(
    (value, projectObj) => {
      // Prevent circular updates when changing from dockyard selection
      if (updatingDockyardRef.current) {
        return;
      }

      updatingProjectRef.current = true;

      try {
        if (value) {
          // Find the selected project
          const project =
            projectObj || projectFilter.find((p) => p._id === value);

          if (project) {
            // Set values
            setDefaultValuesDockyardForm({
              company: project.company._id || project.company,
              project: value,
            });

            setValue("company", project.company._id || project.company);
            setValue("project", value);

            // Only clear dockyard if it doesn't match the current project
            const currentDockyard = getValues("dockyard");
            if (currentDockyard) {
              const dockyardItem = dockyardFilter.find(
                (d) => d._id === currentDockyard
              );
              if (dockyardItem && dockyardItem.project._id !== value) {
                setValue("dockyard", null);
              }
            }
          }
        } else {
          // Clear values when no project selected
          setValue("dockyard", null);
          setValue("company", null);
          setValue("project", null);
          setDefaultValuesDockyardForm({});
        }

        // Clear related fields
        setValue("intervenantCompany", null);
        setValue("intervenantContact", null);
      } finally {
        // Reset the flag after the cycle completes
        setTimeout(() => {
          updatingProjectRef.current = false;
        }, 0);
      }
    },
    [
      projectFilter,
      dockyardFilter,
      setValue,
      setDefaultValuesDockyardForm,
      getValues,
    ]
  );

  /**
   * Handles dockyard selection change
   * Sets project and company based on selected dockyard
   */
  const handleDockyardChange = useCallback(
    (value, dockyardObj) => {
      // Prevent circular updates when changing from project selection
      if (updatingProjectRef.current) {
        return;
      }

      updatingDockyardRef.current = true;

      try {
        if (value) {
          // Find the selected dockyard
          const dockyard =
            dockyardObj || dockyardFilter.find((d) => d._id === value);

          if (dockyard) {
            // Set form values
            setValue("company", dockyard.company._id || dockyard.company);
            setValue("dockyard", value);
            setValue("dispositionAdress", dockyard.address);
            setValue("dispositionAdress2", dockyard.address2);
            setValue("dispositionPostalCode", dockyard.postalCode);
            setValue("dispositionCity", dockyard.city);
            setValue("dispositionCountry", dockyard.country);
            setValue(
              "intervenantCompany",
              dockyard.interveningCompany?.[0]?._id
            );
            setValue("intervenantContact", null);

            // Only update project if it's different
            const currentProjectValue = getValues("project");
            const dockyardProjectId = dockyard.project._id || dockyard.project;

            if (currentProjectValue !== dockyardProjectId) {
              setValue("project", dockyardProjectId);

              // If changing projects, clear the product cart
              if (dockyardProjectId !== currentProject) {
                setValue("products", []);
              }
            }
          }
        } else {
          // Clear dockyard-related values
          setValue("dockyard", null);
        }
      } finally {
        // Reset the flag after the cycle completes
        setTimeout(() => {
          updatingDockyardRef.current = false;
        }, 0);
      }
    },
    [currentProject, dockyardFilter, setValue, getValues]
  );

  return {
    defaultValuesDockyardForm,
    // dockyardFilter,
    // setDockyardFilter,
    setDefaultValuesDockyardForm,

    // functions
    handleCreateProject,
    handleCreateDockyard,
    handleProjectChange,
    handleDockyardChange,

    // pure import
    togglePopinProject,
    errorProject,
    isOpenedProject,
    submittingProject,
    openProjectPopin,
    dockClass,
    toggleDockPopin,
    isDockyardPopinOpened,
    errorDockyard,
    openDockyardPopin,
    submittingDockyard,
  };
}
